import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appTooltip]',
    standalone: false
})
export class TooltipDirective {

  @Input('appTooltip') toolTipTitle: string;
  @Input() placement: string;
  @Input() delay: number;
  tooltip: HTMLElement;
  offset = 10;

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
  ) {

  }

  // event listeners for tooltip
  @HostListener('load') OnLoad() {
    if (this.tooltip) {
      document.querySelector('.ng-tooltip').classList.remove('ng-tooltip-show');
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.showTooltip();

  }

  @HostListener('mouseleave') onMouseLeave() {
    this.hideTooltip();
  }

  @HostListener('window:scroll') OnScroll() {
    this.setTooltipPos();
  }

  // create and show / hide tooltips
  showTooltip() {
    this.setTooltipPos();
    const tooltipElement = document.querySelector('.ng-tooltip');
    tooltipElement.innerHTML = this.toolTipTitle;
    tooltipElement.classList.add('ng-tooltip-show');
  }

  hideTooltip() {
    document.querySelector('.ng-tooltip').classList.remove('ng-tooltip-show');
  }

  createTooltip() {
    this.tooltip = this.renderer.createElement('span');
  }

  // set tooltip position according to it's parent element
  setTooltipPos() {
    this.tooltip = this.renderer.createElement('span');
    const linkPos = this.elRef.nativeElement.getBoundingClientRect();
    const tooltipPos = this.tooltip.getBoundingClientRect();
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    let top, left;

    if (this.placement === 'top') {
      top = linkPos.top - tooltipPos.height - this.offset;
      left = linkPos.left + (linkPos.width - tooltipPos.width) / 2;
    }
    if (this.placement === 'bottom') {
      top = linkPos.bottom + this.offset;
      left = linkPos.left + (linkPos.width - tooltipPos.width) / 2;
    }
    if (this.placement === 'left') {
      top = linkPos.top + (linkPos.height - tooltipPos.height) / 2;
      left = linkPos.left - tooltipPos.width - this.offset;
    }
    if (this.placement === 'right') {
      top = linkPos.top + (linkPos.height - tooltipPos.height) / 2;
      left = linkPos.right + this.offset;
    }
    document.querySelectorAll<HTMLElement>('.ng-tooltip').forEach(el => {
      el.style.top = `${top + scrollPos}px`;
      el.style.left = `${left}px`;
    });
  }

}
